<main class="content-area">
  <h2>PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Orders</h2>
  <button class="btn btn-success btn-sm" (click)="exportToExcel(orders)">Download .xlsx ({{ status }})</button>

  <clr-datagrid [clrDgLoading]="loading">
    <clr-dg-column [clrDgField]="'project_id'">Auftrag</clr-dg-column>
    <clr-dg-column [clrDgField]="'project_name'">Projektname</clr-dg-column>
    <clr-dg-column [clrDgField]="'company_name'">Auftragnehmer</clr-dg-column>
    <clr-dg-column [clrDgField]="'order_details'">Beschreibung</clr-dg-column>
    <clr-dg-column [clrDgField]="'order_confirmation_id'">AB-Nummer (Lieferant)</clr-dg-column>
    <clr-dg-column [clrDgField]="'order_date'" [clrDgSortOrder]="descSort">
      <ng-container *clrDgHideableColumn="{ hidden: true }">
        Datum
      </ng-container>
    </clr-dg-column>
    <clr-dg-column [clrDgField]="'order_delivery'">Liefertermin</clr-dg-column>
    <clr-dg-column>Request</clr-dg-column>
    <clr-dg-column [clrDgField]="'purchasing_price'">Summe (netto)</clr-dg-column>
    <clr-dg-column [clrDgField]="'order_status'">Status</clr-dg-column>
    <clr-dg-placeholder>We couldn't find any Order!</clr-dg-placeholder>
    <clr-dg-row *clrDgItems="let order of orders">
      <clr-dg-cell [routerLink]="['/order/details', order.project_id, order.order_id]">{{ order.project_id }}.0002.{{ order.order_id }}</clr-dg-cell>
      <clr-dg-cell><b>{{ order.project_name }}</b></clr-dg-cell>
      <clr-dg-cell [routerLink]="['/order/details', order.project_id, order.order_id]">
        {{ order.company_name }}
        <span *ngIf="order.order_lastname"><br />({{ order.order_salutation}} {{ order.order_lastname}})</span>
      </clr-dg-cell>
      <clr-dg-cell [routerLink]="['/order/details', order.project_id, order.order_id]">{{ order.order_subject }}</clr-dg-cell>
      <clr-dg-cell [routerLink]="['/order/details', order.project_id, order.order_id]">{{ order.order_confirmation_id }}</clr-dg-cell>
      <clr-dg-cell>{{ order.order_date | date: 'dd.MM.yyyy' }}</clr-dg-cell>
      <clr-dg-cell>{{ order.order_delivery | date: 'dd.MM.yyyy' }}</clr-dg-cell>
      <clr-dg-cell [routerLink]="['/request/details', order.project_id, order.reqid]">{{ order.project_id }}.0001.{{ order.reqid }}</clr-dg-cell>
      <clr-dg-cell class="currency"><b>{{ order.purchasing_price | currency: 'EUR':'code':'1.2-2':'de'  }}</b></clr-dg-cell>
      <clr-dg-cell  [className]="findButtonClass(order.order_status)" role="alert">
        <div class="alert-items">
          <div class="alert-item static">
            <span class="alert-text">{{ getCellStatus(order.order_status).statusDisplay}}</span>
          </div>
        </div>
      </clr-dg-cell>
    </clr-dg-row>
    <clr-dg-footer>
      <clr-dg-pagination #pagination [clrDgPageSize]="50">
        <clr-dg-page-size [clrPageSizeOptions]="[10,25,50,100]">Anfragen pro Seite</clr-dg-page-size>
        {{pagination.firstItem + 1}} - {{pagination.lastItem + 1}}
        von {{orders.length}} Anfrage(n)
      </clr-dg-pagination>
    </clr-dg-footer>
  </clr-datagrid>
</main>
